// extracted by mini-css-extract-plugin
export default {"button_sing_in_override":"tvTf1","#":"EDVzt"};